"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var styled_components_1 = __importDefault(require("styled-components"));
var GridItemComponent = (0, styled_components_1.default)(Box_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-column: ", ";\n  grid-column-start: ", ";\n  grid-column-end: ", ";\n  grid-row: ", ";\n  grid-row-start: ", ";\n  grid-row-end: ", ";\n  place-self: ", "; \n  align-self: ", "; \n  justify-self: ", "; \n  grid-area: ", ";\n"], ["\n  display: grid;\n  grid-column: ", ";\n  grid-column-start: ", ";\n  grid-column-end: ", ";\n  grid-row: ", ";\n  grid-row-start: ", ";\n  grid-row-end: ", ";\n  place-self: ", "; \n  align-self: ", "; \n  justify-self: ", "; \n  grid-area: ", ";\n"])), function (_a) {
    var column = _a.column;
    return column;
}, function (_a) {
    var colStart = _a.colStart;
    return colStart;
}, function (_a) {
    var colEnd = _a.colEnd;
    return colEnd;
}, function (_a) {
    var row = _a.row;
    return row;
}, function (_a) {
    var rowStart = _a.rowStart;
    return rowStart;
}, function (_a) {
    var rowEnd = _a.rowEnd;
    return rowEnd;
}, function (_a) {
    var placeSelf = _a.placeSelf;
    return placeSelf;
}, function (_a) {
    var alignSelf = _a.alignSelf;
    return alignSelf;
}, function (_a) {
    var justifySelf = _a.justifySelf;
    return justifySelf;
}, function (_a) {
    var area = _a.area;
    return area;
});
var GridItem = function (_a) {
    var column = _a.column, colStart = _a.colStart, colEnd = _a.colEnd, row = _a.row, rowStart = _a.rowStart, rowEnd = _a.rowEnd, placeSelf = _a.placeSelf, alignSelf = _a.alignSelf, justifySelf = _a.justifySelf, area = _a.area, children = _a.children, rest = __rest(_a, ["column", "colStart", "colEnd", "row", "rowStart", "rowEnd", "placeSelf", "alignSelf", "justifySelf", "area", "children"]);
    return (react_1.default.createElement(GridItemComponent, __assign({ "data-testid": "grid-item-component", column: column, colStart: colStart, colEnd: colEnd, row: row, rowStart: rowStart, rowEnd: rowEnd, area: area, placeSelf: placeSelf, alignSelf: alignSelf, justifySelf: justifySelf }, rest), children));
};
exports.default = GridItem;
var templateObject_1;
